import type { ReactNode } from 'react';
import React from 'react';

import { css } from '@emotion/react';
import { Text, VStack } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

export type DetailsTextRowProps = {
  value?: ReactNode;
  title?: string;
};

export const DetailsTextRow: React.FC<DetailsTextRowProps> = ({
  value,
  title,
}) => {
  const { t } = useTranslation();
  const textValue = !value ? t('ticket:details.noData') : value;

  return (
    <VStack
      css={css({
        width: 'fit-content',
      })}
    >
      {title && <Text styledAs="body4">{title}</Text>}
      <Text styledAs="body1">{textValue}</Text>
    </VStack>
  );
};
